import './PasswordChangeForm.scss';
import { FormController } from '@form-ts/core';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'src/modules/common/components/Button';
import { BodyMedium01 } from 'src/modules/common/typography/BodyMedium01';
import { BodySmall01 } from 'src/modules/common/typography/BodySmall01';
import { BodySmall02 } from 'src/modules/common/typography/BodySmall02';
import { PasswordField } from 'src/modules/form/components/PasswordField';
import { FormError } from 'src/modules/form/types/FormError';
import { ChangePasswordData } from 'src/modules/profile/types/ChangePasswordData';

type Props = {
  form: FormController<ChangePasswordData, FormError>;
  onChange: () => void;
};

export const PasswordChangeForm = ({ form, onChange }: Props): React.ReactElement => {
  const intl = useIntl();

  return (
    <div className="bp-password-change-form">
      <PasswordField
        autoComplete="new-password"
        field={form.field.at('confirmation')}
        label={intl.formatMessage({ id: 'profile/form/section/changePassword/confirmPassword/label' })}
        maxLength={30}
        minLength={8}
        renderError={(error) => intl.formatMessage({ id: error.message }, error.context)}
        size="md"
      />

      <PasswordField
        autoComplete="new-password"
        field={form.field.at('password')}
        label={intl.formatMessage({ id: 'profile/form/section/changePassword/newPassword/label' })}
        maxLength={30}
        minLength={8}
        renderError={(error) => intl.formatMessage({ id: error.message }, error.context)}
        size="md"
      />

      <div className="bp-password-change-form__requirements">
        <BodyMedium01>
          <FormattedMessage id="profile/form/section/changePassword/requirements"/>
        </BodyMedium01>

        <ul className="bp-password-change-form__list">
          <li className="bp-password-change-form__list-item">
            <BodySmall02>
              <FormattedMessage id="profile/form/section/changePassword/passwordTip1"/>
            </BodySmall02>
          </li>

          <li className="bp-password-change-form__list-item">
            <BodySmall02>
              <FormattedMessage id="profile/form/section/changePassword/passwordTip2"/>
            </BodySmall02>
          </li>

          <li className="bp-password-change-form__list-item">
            <BodySmall02>
              <FormattedMessage id="profile/form/section/changePassword/passwordTip3"/>
            </BodySmall02>
          </li>
        </ul>
      </div>

      <Button
        size="md"
        className="bp-password-change-form__submit"
        kind="primary"
        onClick={onChange}
        type="button"
      >
        {intl.formatMessage({ id: 'profile/form/section/changePassword/button/update' })}
      </Button>
    </div>
  );
};
